// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__vvUWt","page":"styles_page__boey-","active":"styles_active__F8ZBc","ellipsis":"styles_ellipsis__m0yi3"};